var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({attrs:{"href":_vm.href}},_vm.$listeners),[_c('button',{staticClass:"dea-portal-button"},[_c('picture',{staticClass:"dea-portal__icon",attrs:{"aria-label":_vm.ariaLabel}},[_c('img',{attrs:{"src":_vm.src}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }